const SvgOldest = props => (
  <svg height="1em" viewBox="0 0 17 16" width="1em" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0-1h18v18H0z" />
      <g stroke="currentColor">
        <path d="M1 12.552l2.5 2.5 2.5-2.5M3.5 14.5V0" />
      </g>
      <path
        d="M12.25 5.5h-.75V8l2.14 1.27.36-.605-1.75-1.04V5.5M12 3a4.5 4.5 0 0 0-4.5 4.5H6l1.98 2.015L10 7.5H8.5A3.5 3.5 0 1 1 12 11c-.965 0-1.84-.395-2.47-1.03l-.71.71C9.635 11.5 10.75 12 12 12a4.5 4.5 0 0 0 0-9"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgOldest
